import { render } from "./DicomComponent.vue?vue&type=template&id=62807bb9"
import script from "./DicomComponent.vue?vue&type=script&lang=js"
export * from "./DicomComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__